import { render, staticRenderFns } from "./OurClients.vue?vue&type=template&id=2d14fee2&"
import script from "./OurClients.vue?vue&type=script&lang=ts&"
export * from "./OurClients.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports